import * as React from 'react';

function SvgLinkOutline(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.6, d: "M12.57 16.887l-1.99 1.536a4.26 4.26 0 01-5.207-6.747l1.947-1.502M11.474 7.105l1.947-1.503a4.26 4.26 0 015.206 6.747l-1.991 1.537M8.91 14.37l6.18-4.768" })));
}

export default SvgLinkOutline;
